import React from 'react';
import {SubHeading} from '../../components';
import {images} from '../../constants'
import {motion} from 'framer-motion'

const FindUs = () => (
  <div className='fus w-full h-screen pt-20 relative flex items-center justify-center' id='contact'>

          <img src={images.bg} alt=" "  className='absolute right-0 left-0 top-0 bottom-0 -z-10 w-full sm:w-full h-[100vh] sm:h-[100vh]' />
      <div className="w-[80%] m-auto flex flex-col  sm:flex-row justify-center items-center">
            <motion.div
            whileInView={{y: [-100, 0], opacity: [0,1]}}
            transition={{duration: 0.8, type: 'spring'}}
             className="left basis-[100%] sm:basis-[50%] mb-8">
                  <SubHeading title="Contact" />
                  <h1 className='mt-4 mb-12 text-yellow-200 text-4xl font-main font-semibold'>Find Us</h1>
                <p className='text-white'>Lane Ends Bungalow, Whatcroft hall Lane , rudhead, CW9 7SG</p>
                <p className='text-xl text-yellow-200 mb-8'>Opening Hours</p>
                <p className='text-white'> Mon-Fri: 10:00 Am - 02:00 Am</p>
                <p className='text-white'>Sat-Sun: 10:00 Am - 03:00 Am </p>
            </motion.div>
            <motion.div
             whileInView={{y: [100, 0], opacity: [0,1]}}
            transition={{duration: 0.8, type: 'spring'}}
             className="right basis-[100%] sm:basis-[50%]">
              <img src={images.findus} alt="" className='w-full h-96 object-contain' />
            </motion.div>
      </div>
    
  </div>
);

export default FindUs;
